import { render, staticRenderFns } from "./loc-type-cards.vue?vue&type=template&id=130c9832"
import script from "./loc-type-cards.vue?vue&type=script&lang=js"
export * from "./loc-type-cards.vue?vue&type=script&lang=js"
import style0 from "./loc-type-cards.vue?vue&type=style&index=0&id=130c9832&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports